import React, { useEffect, useState } from "react";
import style from "./Rider.module.scss";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinearLoader } from "../../components/Loader/LinearLoader";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import Pagination from "../../components/paginationCopy/Pagination";
import { ridersList } from "../../redux/orders/actions/orders.actions";
import RiderMap from "./RiderMap";
import Search from "../../components/search";
import dateFormat, { constructOrderDate } from "../../helper/DateFormatter";
import {
  EditOutlined,
  EyeOutlined,
  LockOutlined,
  PlusOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import UpdateForm from "./UpdateForm";
import CreateForm from "./CreateForm";
import {
  disableDispatch,
  dispatchDetails,
  enableDispatch,
} from "../../redux/admin/actions/admin.actions";
import { SuccessModal } from "../../components/Modal/SuccessModal";
import MessageInstruction from "../../components/modalInstruction/MessageInstruction";
import { Zoom } from "react-reveal";
import Info from "../../components/InfoCard/Info";
import { RiEBike2Line } from "react-icons/ri";
import RiderDetails from "./RiderDetails";

const Rider = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [ticketModal, setTicketModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [closeModal, setCloseModal] = useState(false);
  const [viewData, setViewData] = useState(false);
  const [dataMatch, setDataMatch] = useState();
  const [riderData, setRiderData] = useState();
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");

  const { rider } = useSelector((state) => state.orderReducer);
  const { dispatchRecord } = useSelector((state) => state.adminReducer);

  const riderCount = rider?.dashboard;
  const riderDetails = rider?.data;

  useEffect(() => {
    setLoading(true);
    dispatch(ridersList());
    setLoading(false);
  }, [dispatch]);

  const handleRow = (data) => {
    setTicketModal(true);
    let match = riderDetails?.find((t) => t?.id === data?.id);
    if (match) {
      setDataMatch(match);
    }
  };

  const handleEdit = (data) => {
    setUpdateModal(true);
    let match = riderDetails?.find((t) => t?.id === data?.id);
    if (match) {
      setRiderData(match);
    }
  };

  const handleData = (data) => {
    dispatch(dispatchDetails({ dispatch_id: data?.dispatch_id }));
    setViewData(true);
  };

  // Search handler
  useEffect(() => {
    setData(
      riderDetails?.filter((id) => {
        return Object.values(id).some((name) =>
          String(name).toLowerCase().includes(search.toLowerCase())
        );
      })
    );
  }, [riderDetails, search]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const size = 10;
  const pagesVisited = pageNumber * size;
  const pageCount = Math.ceil(data?.length / size);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const enableRider = (rider) => {
    if (rider?.status === "Lock") {
      dispatch(enableDispatch(rider?.id));
      dispatch(ridersList());
    } else {
      dispatch(disableDispatch(rider?.id));
      dispatch(ridersList());
    }
  };

  const confirmFunc = () => {
    setUpdateModal(false);
    setCloseModal(true);
  };

  const exitModal = () => {
    setCloseModal(false);
    dispatch(ridersList());
  };

  const handleModal = async () => {
    setCreateModal(false);
    dispatch(ridersList());
  };

  return (
    <>
      <Zoom>
        <div className={style.container}>
          <Info
            bgColor={"#fff"}
            color={"#950303"}
            icon={<RiEBike2Line />}
            value={riderCount?.data}
            cardText={"Total Active Riders"}
          />
          <Info
            bgColor={"#fff"}
            color={"#78A55A"}
            icon={<RiEBike2Line />}
            value={riderCount?.count}
            cardText={"Riders on App"}
          />
        </div>
      </Zoom>
      <div className="d-flex justify-content-between m-3">
        <div className={style.create} onClick={() => setCreateModal(true)}>
          Create <PlusOutlined />
        </div>
        <Search placeholder="Find a dispatch" onChange={handleChange} />
      </div>
      <section style={{ maxWidth: "95%", margin: "auto" }}>
        {loading && <LinearLoader />}
        <Table borderless responsive className="mt-4">
          <thead>
            <tr className={style.TableHeadRow}>
              <th>Id</th>
              <th>
                <div className="d-flex align-items-center align-items-center">
                  Dispatch
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center align-items-center">
                  BikeID
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center align-items-center">
                  Status
                </div>
              </th>

              <th>
                <div className="d-flex align-items-center align-items-center">
                  Location
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center align-items-center">
                  Last Seen
                </div>
              </th>

              <th>
                <div className="d-flex align-items-center align-items-center">
                  Order Count
                </div>
              </th>

              <th>
                <div className="d-flex align-items-center align-items-center">
                  Percentage Completed
                </div>
              </th>

              <th>
                <div className="d-flex align-items-center align-items-center">
                  Battery (%)
                </div>
              </th>
            </tr>
          </thead>
          {data?.length > 0 ? (
            <tbody>
              {data
                ?.sort((a, b) => (a.dispatch_name < b.dispatch_name ? -1 : 1))
                ?.slice(pagesVisited, pagesVisited + size)
                ?.map((ride, index) => (
                  <tr
                    className={`${style.tableBodyRow} ${
                      ride?.status === "out of business" ? style.line : ""
                    }`}
                    key={index}
                  >
                    <td>{pageNumber * size + index + 1}</td>
                    <td style={{ width: "15vw" }}>{ride?.dispatch_name}</td>
                    <td style={{ width: "10vw" }}>{ride?.dispatch_id}</td>
                    <td
                      style={{ width: "8vw" }}
                      className="d-flex align-items-center align-items-center"
                    >
                      {ride?.loca ? (
                        <div
                          style={{
                            background: "lightGreen",
                            padding: "5px",
                            color: "white",
                            borderRadius: "5px",
                            display: "flex",
                            justifyContent: "center",
                            width: "10vw",
                          }}
                        >
                          Trackable
                        </div>
                      ) : (
                        <div
                          style={{
                            background: "#ff726f",
                            padding: "5px",
                            color: "white",
                            borderRadius: "5px",
                            display: "flex",
                            justifyContent: "center",
                            width: "10vw",
                          }}
                        >
                          Untrackable
                        </div>
                      )}
                    </td>
                    <td>{ride?.State}</td>
                    <td>
                      {ride?.last_update_bike
                        ? `${dateFormat.DateYearMonthDay(
                            ride?.last_update_bike
                          )} | 
                          ${dateFormat.TimeOnly(ride?.last_update_bike)}`
                        : "Not Updated"}
                    </td>
                    <td>{ride?.dispatch_order_count}</td>
                    <td>{ride?.percentage_completed}%</td>
                    <td>{ride?.ba3 ? ride?.ba3 : "0"}</td>
                    <td className="d-flex gap-4 justify-content-center align-items-center">
                      <EyeOutlined
                        className={style.action}
                        style={{ color: "gray" }}
                        onClick={() => handleData(ride)}
                      />{" "}
                      <EditOutlined
                        className={style.action}
                        style={{ color: "green" }}
                        onClick={() => handleEdit(ride)}
                      />{" "}
                      {ride?.status === "Lock" ? (
                        <LockOutlined
                          className={style.action}
                          style={{ color: "red" }}
                          onClick={() => enableRider(ride)}
                        />
                      ) : (
                        <UnlockOutlined
                          className={style.action}
                          style={{ color: "lightGreen" }}
                          onClick={() => enableRider(ride)}
                        />
                      )}
                      <button
                        className={ride?.loca ? style.track : style.locked}
                        onClick={() => handleRow(ride)}
                        disabled={!ride?.loca}
                      >
                        Track
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              No record found
            </div>
          )}
        </Table>
        {data?.length > size && (
          <Pagination pageCount={pageCount} onPageChange={changePage} />
        )}
      </section>

      {/* DIALOG MODAL */}
      <ConfirmationModal
        open={ticketModal}
        handleClose={() => setTicketModal(false)}
        closemodal={() => setTicketModal(false)}
        bgcolor="white"
        width="85vw"
        instruction={
          <RiderMap
            lat={parseFloat(dataMatch?.loca.split(",")[0])}
            long={parseFloat(dataMatch?.loca.split(",")[1])}
            riderName={dataMatch?.dispatch_name}
            riderLabel={dataMatch?.dispatch_name.split("")[0]}
          />
        }
      />

      {/* edit MODAL */}
      <ConfirmationModal
        open={updateModal}
        handleClose={() => setUpdateModal(false)}
        closemodal={() => setUpdateModal(false)}
        bgcolor="white"
        width="30vw"
        instruction={
          <UpdateForm
            first_name={riderData?.dispatch_name?.split(" ")[0]}
            last_name={riderData?.dispatch_name?.split(" ")[1]}
            bike_id={riderData?.bike}
            location={riderData?.State}
            id={riderData?.id}
            onClickYes={confirmFunc}
          />
        }
      />

      {/* create MODAL */}
      <ConfirmationModal
        open={createModal}
        handleClose={() => setCreateModal(false)}
        closemodal={() => setCreateModal(false)}
        bgcolor="white"
        width="45vw"
        instruction={
          <CreateForm
            loading={loading}
            onClickYes={() => {
              handleModal();
            }}
          />
        }
      />

      {/* Close MODAL */}
      <SuccessModal
        open={closeModal}
        onClose={() => setCloseModal(false)}
        bgcolor={"#b70303"}
        width="40vw"
        height="35vh"
        instruction={
          <MessageInstruction
            heading={`Dispatch Details Updated Successfully!!`}
            button="OKAY"
            onClickBtn={exitModal}
            color={"#fff"}
          />
        }
      />

      {/* data MODAL */}
      <ConfirmationModal
        open={viewData}
        handleClose={() => setViewData(false)}
        closemodal={() => setViewData(false)}
        bgcolor="white"
        width="60vw"
        instruction={
          <RiderDetails
            type={dispatchRecord?.type?.toUpperCase()}
            lastSeen={constructOrderDate(
              dispatchRecord?.data?.dispatch_info?.last_seen
            )}
            total={dispatchRecord?.data?.data?.total_orders}
            awaiting={dispatchRecord?.data?.data?.awaiting_pickup}
            decline={dispatchRecord?.data?.data?.decline}
            completed={dispatchRecord?.data?.data?.completed_order}
            order={dispatchRecord?.data?.orders}
          />
        }
      />
    </>
  );
};

export default Rider;
